import React from "react";

import noFlag from "./imgs/no-flag.svg";

import {
  MatchBlock,
  StatusTag,
  CourtName,
  RoundText,
  ScoreRow,
  PlayerCell,
  PlayerName,
  ScoreCell,
  ScoresContainer,
  ScoreSection,
  TimeText,
  Flag
} from "./match.styles";

const Match = ({ match }) => {
  const formatUnixTime = (unixTimestamp) => {
    const date = new Date(Number(unixTimestamp) * 1000);
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };

  const { home, away, scores, round, time, matchStatus, points, court } =
    match || {};

  const mapGameStatus = {
    NOT_STARTED: "UPCOMING",
    WALKOVER: "WALKOVER",
    RETIRED: "RETIRED",
    CANCELLED: "CANCELLED",
    ABANDONED: "ABANDONED",
    POSTPONED: "POSTPONED",
    INTERRUPTED: "INTERRUPTED",
    IN_PLAY: "LIVE",
    ENDED: "COMPLETED"
  };

  const isWarning =
    matchStatus === "CANCELLED" ||
    matchStatus === "ABANDONED" ||
    matchStatus === "POSTPONED" ||
    matchStatus === "INTERRUPTED" ||
    matchStatus === "WALKOVER" ||
    matchStatus === "RETIRED";

  return (
    <MatchBlock>
      <CourtName>{court}</CourtName>
      <RoundText>
        {round}
        {mapGameStatus[matchStatus] && (
          <StatusTag warning={isWarning}>
            {mapGameStatus[matchStatus]}
          </StatusTag>
        )}
      </RoundText>
      <TimeText>{formatUnixTime(time)}</TimeText>
      <table style={{ width: "100%" }}>
        <tbody>
          {[home, away].map((player, idx) => {
            return (
              <ScoreRow key={idx}>
                <PlayerCell>
                  <Flag src={player.flag_url || noFlag} alt="flag" />
                  <PlayerName winner={player?.winner}>{player.name}</PlayerName>
                  {/* {player?.winner && <CheckMark>✓</CheckMark>} */}
                </PlayerCell>
                <ScoreSection>
                  <ScoresContainer>
                    {scores &&
                      Object.values(scores)
                        ?.map((set) => ({
                          home: set.home,
                          away: set.away
                        }))
                        .map((set, i) => (
                          <ScoreCell key={i} as="div">
                            {idx === 0 ? set.home : set.away}
                          </ScoreCell>
                        ))}
                  </ScoresContainer>
                  {points && (
                    <ScoreCell as="div" highlighted>
                      {points.split("-")[idx === 0 ? 0 : 1]}
                    </ScoreCell>
                  )}
                </ScoreSection>
              </ScoreRow>
            );
          })}
        </tbody>
      </table>
    </MatchBlock>
  );
};

export default Match;
